import { InputLabel, TextField } from '@mui/material';
import { MuiTelInput } from 'mui-tel-input';
import { IoIosArrowDown } from 'react-icons/io';

const MaInput = ({
  phone,
  label,
  borderColor = '#DADADA',
  textColor = '#000',
  placeholderColor = '#717171',
  labelColor = '#272727',
  height = '46px',
  noHeight,
  SelectProps,
  ...rest
}) => {
  return (
    <div>
      {label && (
        <InputLabel
          sx={{
            fontSize: '13px',
            fontWeight: 600,
            mb: 1,
            fontFamily: 'lato',
            color: labelColor, // ✅ custom label color
          }}
        >
          {label}
        </InputLabel>
      )}

      {phone ? (
        <MuiTelInput
          defaultCountry="US"
          {...rest}
          sx={{
            '& .MuiOutlinedInput-root': {
              fontWeight: 500,
              color: textColor, // ✅ input text color
              fontSize: '13px',
              height: noHeight ? 'auto' : height,
              '& fieldset': {
                borderColor: borderColor, // ✅ border color
                borderRadius: '10px',
                borderWidth: '1px',
              },
              '&:hover fieldset': {
                borderColor: borderColor,
              },
              '&.Mui-focused fieldset': {
                borderColor: borderColor,
              },
            },
            '& .MuiInputBase-input::placeholder': {
              color: placeholderColor, // ✅ placeholder color
              opacity: 1, // so MUI doesn’t fade it
            },
          }}
        />
      ) : (
        <TextField
      
          SelectProps={{
            displayEmpty: true,
            IconComponent: IoIosArrowDown,
            ...SelectProps,
          }}
          {...rest}
          sx={{
            '& .MuiOutlinedInput-root': {
              fontWeight: 500,
              color: textColor, // ✅ input text color
              fontSize: '13px',
              height: noHeight ? 'auto' : height,
              '& fieldset': {
                borderColor: borderColor, // ✅ border color
                borderRadius: '10px',
                borderWidth: '1px',
              },
              '&:hover fieldset': {
                borderColor: borderColor,
              },
              '&.Mui-focused fieldset': {
                borderColor: borderColor,
              },
            },
            '& .MuiInputBase-input::placeholder': {
              color: placeholderColor, // ✅ placeholder color
              opacity: 1, // so MUI doesn’t fade it
            },
          }}
      
        />
      )}
    </div>
  );
};

export default MaInput;
